import type { SVGProps } from 'react';

const SvgPickFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M13.1694 2.75925L15.4776 7.64399C15.5246 7.74354 15.6156 7.81254 15.7208 7.82851L20.882 8.61181C21.9516 8.77415 22.3788 10.1471 21.6048 10.935L17.87 14.7373C17.7939 14.8148 17.7592 14.9264 17.7772 15.0358L18.6588 20.4047C18.8415 21.5173 17.7234 22.3658 16.7666 21.8405L12.1503 19.3057C12.0562 19.254 11.9438 19.254 11.8497 19.3057L7.23335 21.8405C6.27664 22.3658 5.15847 21.5173 5.34118 20.4047L6.22283 15.0358C6.2408 14.9264 6.20606 14.8148 6.12995 14.7373L2.39524 10.935C1.62124 10.147 2.04835 8.77414 3.11799 8.6118L8.27923 7.8285C8.38442 7.81253 8.47535 7.74353 8.52239 7.64398L10.8306 2.75925C11.3089 1.74692 12.6911 1.74692 13.1694 2.75925Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgPickFilled;
